import { render, staticRenderFns } from "./StudentPhoneNumberComponent.vue?vue&type=template&id=aea06c5a&scoped=true&"
import script from "./StudentPhoneNumberComponent.vue?vue&type=script&lang=js&"
export * from "./StudentPhoneNumberComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aea06c5a",
  null
  
)

export default component.exports